export default __webpack_public_path__ + "static/media/CastInactive.c77b9fab.svg";